/*
 * @Description: 谷仓-线索管理模块
 * @Author: mdb
 * @Date: 2022-07-06 13:53:44
 * @LastEditTime: 2023-02-22 14:14:56
 * @LastEditors: mdb
 */
import request from '@/utils/request'
import { AxiosResult } from '@/typings/common'
import {
  SalesClueParams,
  InvalidClueParams,
  SalesClueListResult,
  FbuPublicClueParams,
  FbuPublicClueListResult
} from '@/typings/api/clueManage'

/**
 * ************************************** 销售线索 **************************************
 */
//  获取销售线索列表数据
export function salesClueList(data?: SalesClueParams) {
  return request.post<SalesClueListResult, SalesClueListResult>('/fbu/api/clue/page/list', data)
}
// 删除销售线索
export function salesClueDelete(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/delete', data)
}
// 新增销售线索
export function salesClueCreate(data: any, custom?: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/create', data, custom)
}
// 激活/抢占线索
export function salesClueActivate(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/activate', data)
}
// 修改销售线索
export function salesClueEdit(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/update', data)
}
// 销售线索详情
export function salesClueDetail(data: { clueId: string }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/detail', data)
}
// 退回销售
export function salesClueRefund(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/refund', data)
}
// 申请转有效线索
export function salesClueChangeValid(data: { clueIdList: any[]; applyReason: string }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/apply/change/valid', data)
}
// 置为无效线索
export function salesClueChangeInvalid(data: InvalidClueParams) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/change/invalid', data)
}
//  分配线索
export function salesClueAllot(data: { clueIdList: any[]; follower: string }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/allot', data)
}
//  合并线索
export function salesClueMarge(data: { originalIdList: any[]; targetClueId: string }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/merge', data)
}
// 分页查询线索审核记录列表
export function clueAuditList(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/audit/record/page/list', data)
}
// 申请通过
export function clueApplyPass(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/apply/pass', data)
}
// 申请通过
export function clueRejectPass(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/apply/reject', data)
}
// 申请记录
export function cluerApplyecord(data: any) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/audit/record/detail', data)
}

/**
 * ************************************** 线索公海池 **************************************
 */
//  获取线索公海池列表数据
export function publicClueList(data?: FbuPublicClueParams) {
  return request.post<FbuPublicClueListResult, FbuPublicClueListResult>('/fbu/api/clue/pond/page/list', data)
}
// 领取线索
export function publicClueCollect(data: { clueIdList: any[] }) {
  return request.post<AxiosResult, AxiosResult>('/fbu/api/clue/collect', data)
}
